export default "__VITE_ASSET__4766fd7b__"